import { palette } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import styled from 'styled-components/native';
import LoadingSpinner from '../LoadingSpinner';

const FullScreenLoader: FC<{
  style?: StyleProp<ViewStyle>;
  testID?: string;
}> = ({ style, testID }) => (
  <LoadingScreen style={style} testID={testID}>
    <LoadingSpinner size="large" color={palette.primary_90} />
  </LoadingScreen>
);

const LoadingScreen = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export default FullScreenLoader;
